import React, { useContext, useState, useEffect } from 'react'
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import StickyDelivery from '../../components/CommonForBoth/StickyDelivery'
import { GeneralContext } from '../../context/'
import ApiService from '../../data/services/ApiService'
import DataTable from './components/Datatable'

const Index = () => {
    const generalContext = useContext(GeneralContext)
    const { setLoading } = generalContext

    const [userDefaultAddress, setUserDefaultAddress] = useState({})

    const fetchUserDefaultAddress = async () => {
        try {
            setLoading(true)
            const response = await ApiService.getUserDefaultAddress()
            setUserDefaultAddress(response.data.data)
        } catch (e) {
            if (e.response) {
                toastr.error(`${e.response.data.message}`, 'Error')
            } else {
                toastr.error(`${e}`, 'Error')
            }
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        (async function fetch() {
            await fetchUserDefaultAddress()
        })()
    }, []) // eslint-disable-line

    return (
        <React.Fragment>
            <StickyDelivery
                userDefaultAddress={userDefaultAddress}
            />
            <div style={{ marginTop: '8rem' }}>
                <DataTable
                    userDefaultAddress={userDefaultAddress}
                />
            </div>
        </React.Fragment>
    )
}

export default Index
